module.exports = __webpack_public_path__ + "static/media/course-type.c9d8db49.svg";